import { map } from "rxjs/operators";
import { Observable } from "rxjs/Observable";
import { Inject, Injectable, Injector } from "@angular/core";
import {
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
} from "@angular/common/http";
import { HttpService } from "./http.service";
import { switchMap } from "rxjs/operators";
// import { NbAuthToken } from '../@theme/auth/services/token/token';
// import { NbAuthService, NB_AUTH_TOKEN_INTERCEPTOR_FILTER } from '../@theme/auth/public_api';
// import { ENV } from '../../environments/environment-variables.token';

@Injectable()
export class Interceptor implements HttpInterceptor {
  public token: any;
  public count = 0;
  constructor(private httpService: HttpService, private injector: Injector) {}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    let newRequest = request.clone({});
    this.httpService.getToken().then((data) => {
      if (data) {
        //       this.token = localStorage.getItem("currentUser_token");
        // console.log("his.token", data);
        newRequest = request.clone({
          // params: request.params.append('Authorization', this.token),
          headers: request.headers.set("Authorization", `${data}`),
        });
      }
    });

    // do not intercept request whose urls are filtered by the injected filter
    return next.handle(newRequest);
  }
}
